import CommissionsApi from '../../../../api/commissions-api';
import commissionSchemeActionTypes from '../constants/action-types';
import { handleHttpInProgress } from '../../../shared/http-in-progress/actions/http-in-progress-actions';

export const getPromotions = () => {
  return async dispatch => {
    dispatch(handleHttpInProgress(true));
    try {
      const response = await CommissionsApi.getPromotions();
      const promotions = response && response.data;
      dispatch(handleSuccessGetPromotions(promotions));
      dispatch(handleHttpInProgress(false));
    } catch (error) {
      dispatch(handleHttpInProgress(false));
    }
  };
};

export const handleSuccessGetPromotions = promotions => {
  return {
    type: commissionSchemeActionTypes.HANDLE_SUCCESS_GET_PROMOTIONS,
    data: promotions,
  };
};

export const handleShowVerifiedProfileStepsModal = data => ({
  type: commissionSchemeActionTypes.HANDLE_SHOW_VERIFIED_PROFILE_STEPS_MODAL,
  data,
});



// WEBPACK FOOTER //
// ./src/app/main/commission-scheme/actions/commission-scheme-actions.js